import aiCostsFiltersSignal, {
	setAiCostsFilters,
} from '@UI/Pages/Administration/AiCosts/Filters/Signals/aiCostsFiltersSignal';
import type AiCostFilterOptionsView from '@UI/Store/AiCosts/Views/AiCostFilterOptionsView';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';

type Props = { options: AiCostFilterOptionsView | null };

/** Lists the facilities of the chosen structure, or all of them. */
const FacilityFilter: React.FC<Props> = ({ options }) => {
	const filters = useSignalValue(aiCostsFiltersSignal);
	const facilities = React.useMemo(
		() => options?.facilitiesOf(filters.organizationId) ?? [],
		[options, filters.organizationId],
	);

	const handleChange = React.useCallback((value: number | null) => {
		setAiCostsFilters(aiCostsFiltersSignal.peek().setFacility(value));
	}, []);

	return (
		<Dropdown<number>
			name="aiCostsFacility"
			label="Agence"
			placeholder="Toutes les agences"
			options={facilities}
			optionLabel="label"
			optionValue="id"
			loading={options === null}
			showClear
			filter
			value={filters.facilityId}
			onChange={handleChange}
		/>
	);
};

export default FacilityFilter;
